var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('setting-account-form',{attrs:{"id":Number(_vm.$route.params.id)},on:{"submit":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }